import { Auth0Provider } from "@auth0/auth0-react";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { ColorModeProvider } from "./components/contexts/colormode";
import { initializeDatadogRum } from "./observability/datadog";

initializeDatadogRum();

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_ISSUER_BASE_URL}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `${import.meta.env.VITE_AUTH0_AUDIENCE_BASE_URL}`,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ColorModeProvider>
          <BrowserRouter>
            <CssBaseline />
            <App />
          </BrowserRouter>
        </ColorModeProvider>
      </LocalizationProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
